import Component from '@glimmer/component';

import classMod from 'rise-ui/helpers/class-mod.js';
import eq from 'rise-ui/helpers/eq.js';
import or from 'rise-ui/helpers/or.js';
import sum from 'rise-ui/helpers/sum.js';

export default class StepComponent extends Component {
  <template>
    {{#let
      (eq (sum @step 1) @index)
      (eq @step @index)
      (eq (sum @step -1) @index)
      (or @previousLabel "Previous")
      (or @currentLabel "Current")
      (or @nextLabel "Next")
      (or @stepLabel "Step")
      as | isPrevious isCurrent isNext previousLabel currentLabel nextLabel stepLabel |
    }}
    <div
      class={{classMod "c-step"
        isPrevious "--previous"
        isCurrent "--current"
        isNext "--next"
      }}
      ...attributes
    >
      {{#if (has-block)}}
        {{yield}}
      {{else if isPrevious}}
        {{previousLabel}}
        {{stepLabel}}
      {{else if isCurrent}}
        {{currentLabel}}
        {{stepLabel}}
      {{else if isNext}}
        {{nextLabel}}
        {{stepLabel}}
      {{/if}}
    </div>
    {{/let}}
  </template>
}
